import {
  Button,
  Card,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Spinner,
} from "reactstrap";

import { ChangeEvent, useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { UserProps } from "../context/hooks/useAuth";

const Login = () => {
  const { handleLogin, setSelectTypeUser, selectTypeUser } =
    useContext(AuthContext);

  const [login, setLogin] = useState<UserProps>({
    password: "",
    email: "",
    type: 0,
  });

  const [loading, setLoading] = useState(false);

  const handleLoginClick = async () => {
    setLoading(true);
    await handleLogin(login);
    setLoading(false);
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setLogin((prevLogin) => ({
      ...prevLogin,
      [name]: value,
    }));
  };

  return (
    <>
      <Col lg="6" md="7">
        <Card className="shadow-lg border-0 p-4" style={{ borderRadius: "20px", backgroundColor: "#f0f2f5" }}>
          <img
            style={{ width: "63%" }}
            alt="Logo"
            className="rounded-circle mx-auto d-block mt-3 mb-4"
            src={require("../assets/img/brand/logoAtt.png")}
          />

          <div className="px-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Eu sou um...</small>
            </div>
            <Form>
              <FormGroup className="mb-3 d-flex justify-content-around">
                <div className="custom-control custom-control-alternative custom-checkbox">
                  <input
                    className="custom-control-input"
                    id="customCheckLoginPartner"
                    type="checkbox"
                    checked={selectTypeUser === 1}
                    onChange={() => {
                      setSelectTypeUser(1);
                    }}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customCheckLoginPartner"
                  >
                    <span className="text-muted ml--3">Empresa</span>
                  </label>
                </div>
                {/* <div className="custom-control custom-control-alternative custom-checkbox">
                  <input
                    className="custom-control-input"
                    id="customCheckLoginStudent"
                    type="checkbox"
                    checked={selectTypeUser === 2}
                    onChange={() => {
                      setSelectTypeUser(2);
                    }}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customCheckLoginStudent"
                  >
                    <span className="text-muted ml--3">Instituição</span>
                  </label>
                </div> */}
                <div className="custom-control custom-control-alternative custom-checkbox">
                  <input
                    className="custom-control-input"
                    id="customCheckLoginStudent_3"
                    type="checkbox"
                    checked={selectTypeUser === 4}
                    onChange={() => {
                      setSelectTypeUser(4);
                    }}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customCheckLoginStudent_3"
                  >
                    <span className="text-muted ml--3">Fotógrafo gerente</span>
                  </label>
                </div>
              </FormGroup>
            </Form>

            <Form role="form">
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    name="email"
                    placeholder="Email"
                    type="email"
                    autoComplete="new-email"
                    value={login.email}
                    onChange={handleInputChange}
                    style={{ backgroundColor: "#fff", borderRadius: "10px" }}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    name="password"
                    placeholder="Senha"
                    type="password"
                    autoComplete="new-password"
                    value={login.password}
                    onChange={handleInputChange}
                    style={{ backgroundColor: "#fff", borderRadius: "10px" }}
                  />
                </InputGroup>
              </FormGroup>
              <div className="custom-control custom-control-alternative custom-checkbox">
                <input
                  className="custom-control-input"
                  id="customCheckLogin"
                  type="checkbox"
                />
                <label
                  className="custom-control-label"
                  htmlFor="customCheckLogin"
                >
                  <span className="text-muted">Lembre-me</span>
                </label>
              </div>
              <div className="text-center">
                <Button
                  onClick={handleLoginClick}
                  className="my-4"
                  color="secondary"
                  type="button"
                  disabled={loading}
                  style={{ backgroundColor: "#6c757d", color: "#FFF", borderRadius: "12px" }}
                >
                  {loading && (<Spinner size="sm">Loading...</Spinner>)}
                  {" "}Entrar
                </Button>
              </div>
            </Form>
          </div>
        </Card>
        <Row className="mt-3">
          <Col xs="6">
            <a
              className="text-muted"
              href="#pablo"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/auth/forgot-password"; 
              }}
            >
              <small>Esqueceu a senha?</small>
            </a>
          </Col>
          <Col className="text-right" xs="6">
            <a
              className="text-muted"
              href="#pablo"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/auth/register";
              }}
            >
              <small>Crie uma nova conta</small>
            </a>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default Login;
